import { NextSeo } from "next-seo";
import { getCurrentSeason } from "@/app/nfl/matchups/sitemap";
import HiddenNav from "@/components/hiddenNav";
import Link from "@/components/link/Link";
import NavContainer from "@/components/sitemap/NavContainer";
import Tabs from "@/components/Tabs";
import {
  HEAD_TO_HEAD_PAGE_LINK_CLICKED,
  SITE_MAP_MODULE,
} from "@/constants/amplitude";
import { SEO } from "@/constants/seo";
import {
  SITEMAP_MENU_OPTIONS,
  SITEMAP_MOBILE_MENU_OPTIONS,
} from "@/constants/sitemap";
import { EventSummary } from "@/graphql/gql/graphql";
import { getEventSummaries } from "@/utils/api";
import useSitemapNav from "@/utils/hooks/useSitemapNav";
import styles from "./sitemap.module.scss";

export default function NFLMatchupsSitemap({
  matchups,
}: {
  matchups: EventSummary[];
}) {
  const { mobileOption, mobileSelect, tabSelect, logAmplitudeEvent, selected } =
    useSitemapNav("nfl-matchups");
  return (
    <div className={styles.container}>
      <HiddenNav links={SITEMAP_MOBILE_MENU_OPTIONS} />
      <NextSeo
        title="Sitemap"
        canonical={`${SEO.FANDUEL_URL_RESEARCH}/sitemap/nfl-matchups`}
      />
      <NavContainer mobileOption={mobileOption} mobileSelect={mobileSelect} />
      <div className={styles.sitemapSearchArea}>
        <div className={styles.timeRangeTabs}>
          <Tabs
            dataTestId="sports-tabs"
            items={SITEMAP_MENU_OPTIONS}
            selected={selected}
            setSelected={tabSelect}
          />
        </div>
        <div className={styles.matchups}>
          {matchups.map((matchup) => (
            <p key={matchup.numberfireId}>
              <Link
                next
                onClick={() =>
                  logAmplitudeEvent(HEAD_TO_HEAD_PAGE_LINK_CLICKED, {
                    "Link Text": `${matchup.homeTeam.name} vs. ${matchup.awayTeam.name}`,
                    "Link URL": `/nfl/matchups/${matchup.headToHeadSlug}`,
                    Module: SITE_MAP_MODULE,
                    Competition: "NFL",
                  })
                }
                href={`/nfl/matchups/${matchup.headToHeadSlug}`}
              >
                {matchup.homeTeam.name} vs. {matchup.awayTeam.name}
              </Link>
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}

export async function getServerSideProps() {
  const seasons = [getCurrentSeason()];
  const matchups = (await getEventSummaries(seasons)).eventSummaries ?? [];
  return {
    props: {
      matchups,
    },
  };
}
